/*
 * @Author: amywulan
 * @Date: 2022-03-Mo 11:41:54
 * @Last Modified by:  amywulan
 * @Last Modified time: 2022-03-Mo 11:41:54
 * @description: 开国初始化
 */
import I18nUtil from '@didi/i18n-util'
import store from './store/index.js'
import { setLocalStorage, getLocalStorage } from '@/utils/localStorage'

/**
 * 异步获取country方案
 * 第一步：获取 url 中的 国家code 和countryMap做匹配
 * 第二步：没有匹配成功，请求 c-api common/config 接口反解 country，countryMap做匹配
 * 第三步：capi没有获取到，使用getLocalStorage('countryCode')
 * 若以上步骤均失败，默认取墨西哥 country: MX，
 * country获取优先通过store获取，无法使用store则通过getLocalStorageCountry.js
 */

const { getLocale, getRegion, CountryMap } = I18nUtil
export function openInit() {
  return new Promise(resolve => {
    // 获取locale并存入store
    store.commit('common/setLocale', getLocale())
    if (CountryMap.includes(getRegion())) {
      // 获取国家并存入store
      store.commit('common/setCountry', getRegion())
      setLocalStorage('countryCode', getRegion())
    } else {
      // const res = await store.dispatch('common/getCountry') ||{}
      // const country = CountryMap.includes(res?.country)? res?.country :(getLocalStorage('countryCode')||'MX')
      const country = getLocalStorage('countryCode') || 'MX'
      store.commit('common/setCountry', country)
      setLocalStorage('countryCode', country)
    }

    const url = new URL(window.location.href)
    const path = url.pathname // "/es-MX/fo"
    // 提取 locale（如 "es-MX"）
    const parts = path.split('/')
    const extractedLocale = parts[1] // "es-MX"
    // 预定义的语言列表
    const supportedLanguages = [
      'en-US',
      'es-419',
      'es-MX',
      'ja-JP',
      'pt-BR',
      'zh-CN',
      'es-CR',
      'es-CO',
      'es-DO',
      'es_PE',
    ]

    // 检查提取的 locale 是否在 supportedLanguages 中（不区分大小写）
    const matchedLocale = supportedLanguages.find(
      lang => lang.toLowerCase() === extractedLocale.toLowerCase(),
    )

    // 如果匹配到，使用匹配到的值；否则默认返回 'es-MX'
    const finalLocale = matchedLocale || getLocale() || 'es-MX'
    console.log('匹配到的语言或默认 es-MX', finalLocale) // 输出匹配到的语言或默认 'es-MX';

    setLocalStorage('finalLocale', finalLocale) // 存储最终的语言设置,用来给售后设置
    resolve()
  })
}
